export default{
    sagaUrl: 'https://api.softverk.co.th/api'
};


// WEBPACK FOOTER //
// ./src/config/localConfig.ts